import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  CustomTextFieldControlMessageMeta,
  NumberFieldSingleSelectControlMessageMeta,
  TextFieldControlMessageMeta,
  MultiLineTextFieldControlMessageMeta,
} from 'api/conversations';
import { FieldOption } from 'api/tasks';
import { tryGetTextFromHTML } from 'utils/getTextFromHTML';

export const SingleSelectControlMessage: FC<{
  meta:
    | CustomTextFieldControlMessageMeta
    | TextFieldControlMessageMeta
    | MultiLineTextFieldControlMessageMeta
    | NumberFieldSingleSelectControlMessageMeta;
  rootKey: string;
  userName: string;
}> = ({ meta, rootKey, userName }) => {
  let keyForString = rootKey;

  if (meta.customField) {
    keyForString += '.CUSTOM';
  }
  if (!meta.oldValue) {
    keyForString += '.ADDED';
  } else if (!meta.newValue) {
    keyForString += '.REMOVED';
  } else {
    keyForString += '.UPDATED';
  }

  // NOTE:: The .toString() is a hack to solve for {} in newValue/oldValue for TEXT types.
  switch (meta.customField) {
    case true: {
      const from = tryGetTextFromHTML(
        meta.optionsAvailable
          ? (meta.oldValue as FieldOption<string>)?.label
          : `${meta.oldValue}`,
      );

      const to = tryGetTextFromHTML(
        meta.optionsAvailable
          ? (meta.newValue as FieldOption<string>)?.label
          : `${meta.newValue}`,
      );

      return (
        <FormattedMessage
          id={keyForString}
          values={{
            changedByUserName: userName,
            label: meta.fieldLabel || meta.fieldName,
            from,
            to,
          }}
        />
      );
    }
    case false:
    default:
      return (
        <FormattedMessage
          id={keyForString}
          values={{
            changedByUserName: userName,
            label: meta.fieldLabel || meta.fieldName,
          }}
        />
      );
  }
};
